import React, { useEffect, useState } from "react";
import "./Profile.css";
import Header from "../../Layout/Header";
import Header2 from "../../Layout/Header2";
import checkIcon from "../../Images/circle-check-solid.svg";
import { toast } from "react-toastify";
import AuthService from "../../Services/AuthService";
import { data, useNavigate } from "react-router-dom";
import HomeService from "../../Services/HomeService";
import UserProfile from "./UserProfile";
const Profile = () => {
  const [isRightPanelActive, setIsRightPanelActive] = useState(false);
  const [email, setEmail] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loginProfile, setLoginProfile] = useState(false);
  const [token, setToken] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [getCitiesForUser, setGetCitiesForUser] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  const [registerDetails, setRegisterDetails] = useState({
    email: "",
    otp: "",
    fullName: "",
    password: "",
    city: "",
    companyName: "",
    address: "",
    mobileNo: "",
    workExpYear: "",
  });

  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  // const passWord = password.length >= 4 && password.length <= 15;

  const navigate = useNavigate();

  const handleSignUpClick = () => {
    setIsRightPanelActive(true);
  };

  const handleSignInClick = async () => {
    setIsRightPanelActive(false);
  };

  const getLoginProfile = async () => {
    const res = await HomeService.getLoginProfile();
    // console.log("login profile response", res);

    setLoginProfile(res.status);
    // console.log("login profile", loginProfile);
  };

  const handleLogIn = async (e) => {
    e.preventDefault();
    // console.log("login clicked");

    const isValid = loginEmail.trim() !== "" && loginPassword.trim() !== "";
    if (isValid) {
      if (!loginEmail.match(mailFormat)) {
        toast.error("Invalid Email");
      } else {
        const data = {
          email: loginEmail,
          password: loginPassword,
        };
        const res = await AuthService.getLogin(data);

        // console.log("this data is during login", res);

        if (res?.status) {
          toast.success("Logged in successfully!");
          localStorage.setItem("token", res?.data?.token);
          navigate("/");
          // console.log("6df5g6f4dg646fd", res)
          // getLoginProfile()
        } else {
          toast.error(res?.message);
        }
      }
    } else {
      toast.error("Please fill all the Inputs..");
    }
  };

  const handleVerifyEmail = async () => {
    const isValid = email.trim() !== "";

    if (isValid) {
      if (!email.match(mailFormat)) {
        toast.error("Invalid Email");
      } else {
        const data = { email: email };
        const res = await HomeService.verifyEmail(data);

        if (res && res.status === false) {
          toast.error("Your account already registered. Please login");
          setIsRightPanelActive(false);
        }

        if (res && res.status) {
          toast.success("OTP Has been sent!");
          setRegisterDetails((prevDetails) => ({
            ...prevDetails,
            email: email,
          }));

          setOtp(res.data);
          setIsEmailVerified(true); // ✅ Set to true when email is verified
        }
      }
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    // console.log("handle signup is clicked");

    const {
      email,
      otp,
      fullName,
      password,
      city,
      companyName,
      address,
      mobileNo,
      workExpYear,
    } = registerDetails;

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      // console.log("password do not match");

      return;
    }
    if (
      !email ||
      !otp ||
      !fullName ||
      !password ||
      !city ||
      !companyName ||
      !address ||
      !mobileNo ||
      !workExpYear
    ) {
      toast.error("Please verify your email and fill all fields!");
      return;
    }
    // console.log("sjflsdfsl");

    try {
      // console.log("this data is send to register", registerDetails);

      const res = await AuthService.register(registerDetails);
      // console.log("this data is after register", res);

      if (res?.status) {
        toast.success("Registration successful! Please log in.");
        setIsRightPanelActive(false);
      } else {
        toast.error(res?.message || "Registration failed.");
        // console.log("registration failed");
      }
    } catch (error) {
      toast.error("Error during registration.");
      console.log("error during registration");
    }
  };
  useEffect(() => {
    getLoginProfile();

    const token = localStorage.getItem("token");
    // console.log("token", token);

    if (token) {
      setToken(true);
    } else {
      setToken(false);
    }
  }, [token]);

  const fetchCitiesForUser = async () => {
    try {
      const res = await HomeService.getCitiesForUser();
      console.log(res.data);
      setGetCitiesForUser(res.data);
    } catch (error) {
      console.error("error in fetching City Details", error);
      toast.error("Error Fetching City Details!");
    }
  };

  useEffect(() => {
    fetchCitiesForUser();
  }, []);

  const handleChange = (e) => {
    setSelectedCity(e.target.value);
    //console.log("Selected City ID:", e.target.value);
    setRegisterDetails({
      ...registerDetails,
      city: e.target.value,
    });
  };

  return (
    <>
      <div className="form_wrapper856">
        <Header2 />
        {!loginProfile ? (
          <div
            className={`container2  ${
              isRightPanelActive ? "right-panel-active" : ""
            }`}
            id="container"
          >
            {/* Sign Up Container */}
            <div className="form-container sign-up-container">
              <form className="form_class" action="#">
                <h1 className="create_account_para">Sign Up</h1>
                <p className="sign_up_para565">
                  Already have an account?{" "}
                  <span
                    className="span_sign_up"
                    style={{ cursor: "pointer" }}
                    onClick={handleSignInClick}
                  >
                    Sign In
                  </span>
                </p>
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Name"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      fullName: e.target.value,
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="email"
                  placeholder="Enter Email Addresss"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    // setRegisterDetails({
                    //   ...registerDetails,
                    //   email: e.target.value,
                    // });
                  }}
                  value={email}
                />
                <div className="d-flex justify-content-end w-100">
                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      fontFamily: "Roboto",
                      cursor: "pointer",
                    }}
                    onClick={handleVerifyEmail}
                  >
                    Verify Email
                  </p>

                  {/* ✅ Show verified icon if email is successfully verified */}
                  {isEmailVerified && (
                    <img
                      src={checkIcon}
                      alt="Verified"
                      style={{
                        width: "16px",
                        height: "16px",
                        marginLeft: "8px",
                      }}
                    />
                  )}
                </div>
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Code Received on Email"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      otp: e.target.value,
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Company Name"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      companyName: e.target.value,
                    })
                  }
                />
                {/* <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter City"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      city: e.target.value,
                    })
                  }
                /> */}

                <select
                  className="input_class5566"
                  value={selectedCity}
                  onChange={handleChange}
                >
                  <option value="">-----Select City-----</option>
                  {getCitiesForUser.map((city, i) => {
                    return (
                      <option key={i} value={city._id}>
                        {city.name}
                      </option>
                    );
                  })}
                </select>

                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Address"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      address: e.target.value,
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Contact Number"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      mobileNo: Number(e.target.value),
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Work Experience"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      workExpYear: Number(e.target.value),
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="password"
                  placeholder="Password"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      password: e.target.value,
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  className="submit_btn6565"
                  type="submit"
                  onClick={handleSignUp}
                >
                  Sign Up
                </button>
              </form>
            </div>

            {/* Sign In Container */}
            <div className="form-container sign-in-container">
              <form className="form_class" action="#">
                <h1 className="create_account_para">Log in</h1>
                <p className="sign_up_para565">
                  Doesn't have an account yet ?{" "}
                  <span className="span_sign_up" onClick={handleSignUpClick}>
                    Sign Up
                  </span>
                </p>

                <input
                  className="input_class5566"
                  type="email"
                  placeholder="Email"
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                />
                <input
                  className="input_class5566"
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                />
                <a className="social" href="#">
                  Forgot your password?
                </a>
                <button
                  className="submit_btn6565"
                  type="submit"
                  onClick={(e) => handleLogIn(e)}
                >
                  Log In
                </button>
              </form>
            </div>

            {/* Overlay Container */}
            <div className="overlay-container">
              <div className="overlay">
                <div className="overlay-panel overlay-left">
                  <h1
                    style={{
                      fontWeight: "700",
                    }}
                  >
                    Welcome Back!
                  </h1>
                  <p
                    className="para565"
                    style={{
                      fontWeight: "700",
                    }}
                  >
                    To keep connected with us please login with your personal
                    info
                  </p>
                  <button
                    className="  submit_btn6565 ghost"
                    id="signIn"
                    style={{
                      cursor: "pointer",
                      background: "white",
                      color: "rgb(0, 52, 102)",
                    }}
                    onClick={handleSignInClick}
                  >
                    Sign In
                  </button>
                </div>
                <div className="overlay-panel overlay-right">
                  <h1
                    style={{
                      color: "rgb(0, 52, 102)",
                      fontWeight: "700",
                    }}
                  >
                    Hello, Friend!
                  </h1>
                  <p
                    className="para565"
                    style={{
                      color: "rgb(0, 52, 102)",
                      fontWeight: "700",
                    }}
                  >
                    Enter your personal details and start your journey with us
                  </p>
                  <button
                    className=" submit_btn6565 ghost"
                    style={{
                      border: "none",
                      background: "rgb(0, 52, 102)",
                    }}
                    id="signUp"
                    onClick={handleSignUpClick}
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <UserProfile />
        )}
        {/* Add UserProfile Component Below */}

        {/* <UserProfile /> */}
      </div>
    </>
  );
};

export default Profile;
